import { useContext, useMemo } from 'react';
import { UserContext } from '../auth/UserContext';
import { DEFAULT_LANG, LOCALE } from '../constants/constants';
import { LOCALE_REPLACE, supportedL10n } from '../i18n/localization';

export const useBrowserOrAccountLocale = (): string => {
    const userContext = useContext(UserContext);

    return useMemo(() => {
        const localeAttr = userContext?.organizationAccountDetails?.attributes?.find((attr) => attr.name === LOCALE);
        const localeValue = localeAttr?.value || '';

        const locale = Object.keys(supportedL10n).find((key) => supportedL10n[key].label === localeValue);
        const browser = navigator?.languages.length ? navigator.languages[0] : navigator.language;

        return locale || LOCALE_REPLACE[browser] || browser || DEFAULT_LANG;
    }, [userContext?.organizationAccountDetails]);
};
